import { Modal } from 'antd';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import RegisterForm from '../../Auth/RegisterForm';
import { AppDispatch } from '../../../../store/app';
import { useDispatch } from 'react-redux';
import { fetchEditUser } from '../../../../store/UserSlice';

const EditUser: React.FC<any> = (props) => {
  const { handleEditModal, openEditModal, dataEditModal, getList } = props;
  const dispatch: AppDispatch = useDispatch();

  const handleSubmit = (data: any) => {
    dispatch(fetchEditUser(data))
      .then((res: any) => {
        handleEditModal();
        getList();
      })
      .catch((error: any) => {
        console.log('error', error);
      });
  };

  return (
    <>
      <Modal
        open={openEditModal}
        destroyOnClose
        width={800}
        onCancel={handleEditModal}
        closeIcon={<FontAwesomeIcon icon={faTimes} />}
        footer={false}
        className="editModal"
        title={`Edit User`}
      >
        <RegisterForm
          isEdit={true}
          isAdd={true}
          dataEditModal={dataEditModal}
          editSubmit={handleSubmit}
        />
      </Modal>
    </>
  );
};

export default EditUser;
